<template>
    <v-card elevation="0">
        <v-card-title class="mt-n2">
            <div class="headline">{{$t('Guest Accounts')}}</div>
            <v-spacer></v-spacer>
            <v-btn :disabled="!selectedGuests.length" :dark="!!selectedGuests.length" color="red" @click="deleteGuest">
                Delete Selected ({{selectedGuests.length}})
            </v-btn>
            <v-btn v-if="false" class="ml-3" color="primary" @click="$router.push({name: 'guest-batch-add'})">
                {{$t('guest.create')}}
                <v-icon right>mdi-plus</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col>
                    <v-select clearable
                              :label="$t('event.companyId')"
                              :placeholder="$t('event.companyId')"
                              :items="companyOptions"
                              v-model="filterByCompanyId">
                    </v-select>
                </v-col>
                <v-col>
                    <v-text-field v-model="search"
                                  append-icon="mdi-magnify"
                                  :label="$t('search')"
                                  single-line
                                  hide-details>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-data-table :headers="headers"
                          :items="guests"
                          :search="search"
                          v-model="selectedGuests"
                          :no-data-text="filterByCompanyId ? 'No data available' : 'Please Select Company'"
                          show-select>
                <template v-slot:item.companyId="{value}">
                    {{(companyMap[value])?companyMap[value].name:""}}
                </template>
                <template v-slot:item.createdAt="{value}">
                    {{DateTime.fromISO(value).toFormat('yyyy-MM-dd HH:mm')}}
                </template>
                <template v-slot:item.updatedAt="{value}">
                    {{DateTime.fromISO(value).toFormat('yyyy-MM-dd HH:mm')}}
                </template>
                <template v-slot:item.actions="{item}">
                    <v-btn color="primary"
                           :to="{name: 'guest-edit', params: {guestId:item.id}}">
                        {{$t('edit')}}
                        <v-icon right>mdi-pencil</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card-text>
        
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        
        <v-dialog v-model="dialog" scrollable max-width="640px">
            <v-card>
                <v-card-text style="height: 360px; padding: 15px" v-html="dialogMsg">
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>

</template>

<script>
    import {computed, ref, watch} from "@vue/composition-api";
    import {useFind} from "feathers-vuex";
    import {DateTime} from "luxon";
    import feathersClient from "@/feathers-client";

    export default {
        name: 'GuestList',
        setup(props, {root}) {
            const {Guest, Company} = root.$FeathersVuex.api;
            
            const overlay = ref(false);
            const dialog = ref(false);
            const dialogMsg = ref('');

            const selectedGuests = ref([]);

            const companyParams = computed(() => {
                return {
                    query: {
                        $sort: {
                            name: 1,
                        }
                    }
                }
            });
            const companyData = useFind({model: Company, params: companyParams});
            const companyOptions = computed(() => {
                return companyData.items.value.map(c => {
                    return {text: c.name, value: c.id}
                });
            });
            const companyMap = computed(() => {
                let map = {};

                companyData.items.value.forEach(c => {
                    map[c.id] = c;
                });

                return map;
            });
            
            /*const userCompanySelection = computed(() => {
                return (root.$store.state.auth.user && root.$store.state.auth.user.company) ? root.$store.state.auth.user.company.id : (root.$store.state.prefilledCompanyId ? root.$store.state.prefilledCompanyId : undefined);
            });
            watch(userCompanySelection, (selection) => {
                if (filterByCompanyId && selection) {
                    filterByCompanyId.value = selection;
                }
            });*/
            
            const filterByCompanyId = ref(root.$store.state.prefilledCompanyId);
            watch(filterByCompanyId, (companyId) => {
                if (selectedGuests) selectedGuests.value = [];
                root.$store.commit('setPrefilledCompanyId', companyId || '');
            });

            const guestParams = computed(() => {
                let params = {
                    query: {
                        $sort: {
                            createdAt: -1,
                        }
                    }
                };

                if (filterByCompanyId && filterByCompanyId.value) {
                    params.query['companyId'] = filterByCompanyId.value;
                } else {
                    params.query['id'] = 0;
                }
                return params;
            });
            const {items: guests, isPending: isGuestPending} = useFind({model: Guest, params: guestParams});

            // Data Table
            const search = ref('');
            const headers = ref([
                {text: root.$t('guest.username'), value: 'username'},
                // {text: root.$t('guest.name'), value: 'name'},
                // {text: 'Email', value: 'ev_email'},
                {text: root.$t('guest.created_at'), value: 'createdAt', filterable: false},
                {text: '', value: 'actions', filterable: false, width: '120', align: 'end'},
            ]);
            
            const deleteGuest = async () => {
                if (confirm(root.$t('user.confirm_delete'))) {
                    overlay.value = true;

                    let selectedGuests_array = [];
                    if (selectedGuests.value.length === 0) {
                        overlay.value = false;
                        return;
                    } else if (selectedGuests.value.length > 20) {
                        for (let i = 0; i < selectedGuests.value.length; i += 20) {
                            selectedGuests_array.push(selectedGuests.value.slice(i, i + 20));
                        }
                    } else {
                        selectedGuests_array.push(selectedGuests.value);
                    }

                    for (let i = 0; i < selectedGuests_array.length; i++) {
                        await feathersClient.service('guests').remove(null, {
                            query: {
                                id: {
                                    $in: selectedGuests_array[i].map(g => g.id)
                                }
                            }
                        }).then(() => {
                            selectedGuests.value = selectedGuests.value.filter(g => !selectedGuests_array[i].includes(g));
                        }).catch(e => {
                            overlay.value = false;
                            root.$store.dispatch('showSnackBar', e.message);
                            return;
                        });
                    }

                    overlay.value = false;
                    root.$store.dispatch('showSnackBar', 'Guests Deleted.');

                    // let count = 0;
                    // let errorCount = 0;
                    // let errorMsg = '';
                
                    // let i = selectedGuests.value.length;
                    // while (i--) {
                    //     let temp = await selectedGuests.value[i].remove().then(() => {
                    //         selectedGuests.value.splice(i, 1);
                    //         return false;
                    //     }, (e) => {
                    //         return e.errors ? e.errors.map ? (e.errors.map(a => a.message)).join('; ') : e.message : e.statusText;
                    //     });
                    //     count++;
                    //     if (temp) {
                    //         errorMsg = '<li>' + temp + '</li>' + errorMsg;
                    //         errorCount++;
                    //     }
                    // }
                
                    // overlay.value = false;
                    // if (errorCount) {
                    //     dialogMsg.value = (count - errorCount) + ' of ' + count + ' Account(s) sucessfully deleted.<br><br>' + (errorCount) + ' of ' + count + ' Account(s) NOT deleted:<br><ul>' + errorMsg + '</ul>';
                    //     dialog.value = true;
                    // } else {
                    //     dialogMsg.value = '';
                    //     root.$store.dispatch('showSnackBar', count + ' Account(s) Deleted.' + errorMsg);
                    // }
                }
            };

            return {
                filterByCompanyId,
                companyOptions,
                companyMap,

                guestParams,
                guests,

                search,
                headers,
                DateTime,
                
                overlay,
                dialog,
                dialogMsg,
                
                selectedGuests,
                deleteGuest
            }
        }
    }
</script>
